<template>
  <section>
    <div
      class="container"
      :hidden="isHidden"
    >

      <!-- Media -->
      <div class="columns">
        <div class="column is-one-third">
          <figure
            v-if="$store.state.listing.attributes.pictureUrls.length > 0"
            @click="showLightbox($store.state.listing.attributes.pictureUrls[0])"
          >
            <a><img v-bind:src="$store.state.listing.attributes.pictureUrls[0]">
              <div class="level-item">{{ 1 }} of {{ $store.state.listing.attributes.pictureUrls.length }}</div>
            </a>
          </figure>
          <figure
            class="image is-128x128"
            v-if="$store.state.listing.attributes.pictureUrls.length == 0"
          >
            <img src="
                    https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg">
          </figure>

          <a
            v-if="!$store.state.listing.attributes.isActive"
            class="level-item button is-primary is-large is-full-width is-outlined"
            style="margin-top: 50px; height: 100px"
            disabled
          >
            Listing Not Active
          </a>

          <div
            class="level-item button is-primary is-large is-full-width is-outlined"
            style="margin-top: 50px; height: 100px"
            v-if="$store.state.listing.attributes.isActive"
            disabled
          >
            Apply Now (Coming Soon)
          </div>

          <div
            class="level-item button is-info is-large is-full-width is-outlined"
            style="margin-top: 50px; height: 70px"
            v-if="$store.state.listing.attributes.isActive"
            disabled
          >
            Question? (Coming Soon)
          </div>

        </div>

        <div class="column">

          <!-- Summary  -->
          <div class="title">{{ $store.state.listing.attributes.street }}</div>
          <div class="subtitle">{{ $store.state.listing.attributes.city }}, {{ $store.state.listing.attributes.state }} {{ $store.state.listing.attributes.zip }}</div>
          <div class="subtitle">{{ $store.state.listing.attributes.beds }} bd, {{ $store.state.listing.attributes.baths }} ba, {{ $store.state.listing.attributes.sqft }} sqft | {{ $store.state.listing.attributes.availableDate | availableDate }}</div>

          <div class="is-divider" />

          <!-- Property & Rent Details -->
          <div class="subtitle has-text-weight-semibold">{{ $store.state.listing.attributes.title }}</div>
          <p>{{ $store.state.listing.attributes.description }}</p>

          <div class="is-divider" />

          <!-- Details -->
          <div class="columns">
            <div
              class="column"
              v-if="$store.state.listing.attributes.features.length > 0"
            >
              <div class="subtitle has-text-weight-semibold">Features</div>
              <ul>
                <li
                  v-for="feature in $store.state.listing.attributes.features"
                  v-bind:key="feature"
                >
                  {{ feature }}
                </li>
              </ul>
            </div>

            <div
              class="column"
              v-if="$store.state.listing.attributes.rentPolicy"
            >
              <div class="subtitle has-text-weight-semibold">Rent</div>
              <p>{{ $store.state.listing.attributes.rentPolicy }}</p>
            </div>

            <div
              class="column"
              v-if="$store.state.listing.attributes.depositPolicy"
            >
              <div class="subtitle has-text-weight-semibold">Deposit</div>
              <p>{{ $store.state.listing.attributes.depositPolicy }}</p>
            </div>

            <div
              class="column"
              v-if="$store.state.listing.attributes.applicationPolicy"
            >
              <div class="subtitle has-text-weight-semibold">Application</div>
              <p>{{ $store.state.listing.attributes.applicationPolicy }}</p>
            </div>

            <div
              class="column"
              v-if="$store.state.listing.attributes.petPolicy"
            >
              <div class="subtitle has-text-weight-semibold">Pets</div>
              <p>{{ $store.state.listing.attributes.petPolicy }}</p>
            </div>
          </div>

        </div>

      </div>

      <lightbox
        id="mylightbox"
        ref="lightbox"
        :images="images"
        :timeoutDuration="5000"
      ></lightbox>

    </div>

  </section>
</template>

<script>
import LightBox from "vue-image-lightbox";

export default {
  components: { LightBox },

  props: {
    property_id: undefined,
    listing_id: undefined
  },

  data() {
    return {
      images: [],
      isHidden: true
    };
  },

  methods: {
    showLightbox: function(imageName) {
      this.$refs.lightbox.show(imageName);
    }
  },

  async mounted() {
    this.$store.state.listing.attributes.isActive = true;
    this.$store.state.isLoginRequired = false;
    this.$store.state.isPublicListing = true;

    var propertyId = this.property_id;
    var listingId = this.listing_id;

    await this.$store.dispatch("getListing", { propertyId, listingId });

    var images = [];
    var totalPictureCount = this.$store.state.listing.attributes.pictureUrls
      .length;
    this.$store.state.listing.attributes.pictureUrls.forEach(function(
      pictureUrl,
      index
    ) {
      var pictureNumber = index + 1;
      images.push({
        name: pictureUrl,
        alt: `${pictureNumber} of ${totalPictureCount}`
      });
    });
    console.log("images", images);
    this.images = images;

    this.isHidden = false;
  },

  beforeDestroy() {
    this.$store.state.isLoginRequired = true;
  }
};
</script>

<style>
</style>
